import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NoEncryptionGmailerrorredIcon(props: IconProps) {
    return <Icon {...props} iconKey={"no_encryption_gmailerrorred"}/>
}
